import React, { useEffect, useRef, useState } from "react";
import CustomerTableWrapper from "src/Components/Customer/CustomerTableWrapper";
import PageHeader from "src/Components/Customer/PageHeader";
import { Modal } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { convertToKebabCase } from "src/helpers/helperFunctions";
import AllCustomerPrescription from "src/Components/DoctorComponents/AllCustomerPrescription";
import SingleChat from "../ChatApp/SingleChat";
import AllCustomerReports from "src/Components/DoctorComponents/AllCustomerReports";
import BackIcon from "src/assets/images/back-icon.png";
import { ILatestChat } from "src/types/GlobalInterfaces";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "src/Store/store";

const MyCustomerManage = () => {
  let navigate = useNavigate();
  let [searchParams] = useSearchParams();
  let tab = searchParams.get("tab") || "prescriptions";
  const LineHeight = useRef<HTMLDivElement>(null);
  const { latestChat } = useSelector((store: RootState) => store.chat);
  const containerRef = useRef<HTMLDivElement>(null);
  const { id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const { redDots } = useSelector((store: RootState) => store.redDots);

  let tabs = [
    {
      title: "Prescriptions",
      key: "prescriptions",
      count: 0,
    },
    {
      title: "Chats",
      key: "chats",
      count: latestChat?.find(
        (chat: ILatestChat) => chat._id === id && chat.unRead > 0
      )
        ? 1
        : 0,
    },
    {
      title: "Reports",
      key: "reports",
      count: redDots.reportNotified,
    },
  ];
  const [chatBarHeight, setChatBarHeight] = useState<number>(200);

  // Calculate proper height for chat container
  const calculateChatHeight = () => {
    if (LineHeight.current && containerRef.current) {
      const viewportHeight = window.innerHeight;
      const headerHeight = LineHeight.current.offsetTop;
      const tabsHeight = LineHeight.current.offsetHeight;
      const hrHeight = 1; // Height of the hr element
      const padding = 55; // Additional padding for margins

      const calculatedHeight =
        viewportHeight - headerHeight - tabsHeight - hrHeight - padding;
      setChatBarHeight(Math.max(calculatedHeight, 350)); // Minimum height of 350px
    }
  };

  useEffect(() => {
    // Initial calculation
    calculateChatHeight();

    // Recalculate on window resize
    const handleResize = () => {
      calculateChatHeight();
    };

    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [tab]); // Recalculate when tab changes

  const BackButton: React.FC = () => {
    return (
      <button
        className="right-bar-icon"
        onClick={() => navigate(`/my-customers`)}
      >
        <img src={BackIcon} alt="back-icon" />
      </button>
    );
  };

  return (
    <>
      <PageHeader title="My Customers" isButton ButtonComponent={BackButton} />
      <div
        className="parent-box !mb-1 !pb-3 test-result-cloum-center"
        ref={containerRef}
      >
        <div className="flex items-center gap-2" ref={LineHeight}>
          {tabs.map((item, index) => (
            <button
              onClick={() => {
                navigate(`/doctor/my-customers/manage/${id}?tab=${item.key}`);
              }}
              key={item.key}
              id={`appointment-tab-${convertToKebabCase(item.title)}`}
              className={`relative border font-size-15px font-Poppins-SemiBold health-tabs-main-btn rounded-full ${
                tab === item.key
                  ? "text-[#fff] theme-bg-green"
                  : "theme-color-green border-[#004540]"
              }`}
            >
              {item.title}
              {item.count > 0 && (
                <div className="red-dot-show absolute -top-1 -right-1"></div>
              )}
            </button>
          ))}
        </div>
        <hr className={`products-tabs-hr-allOrder`} id="chat-tab-hr" />
        {/* <div className="w-full"></div> */}
        {tab === "prescriptions" && (
          <AllCustomerPrescription customerID={id || ""} />
        )}
        {tab === "chats" && (
          <div
            className="w-full box-design"
            style={{
              height: `${chatBarHeight}px`,
              overflow: "hidden",
              // backgroundColor: 'red' // Prevent scrolling on container
            }}
          >
            <SingleChat isCustomerSide doctorID={id} />
          </div>
        )}
        {tab === "reports" && <AllCustomerReports customerID={id || ""} />}
      </div>
    </>
  );
};

export default MyCustomerManage;
